import ICCardInput from './ICCardInput';

export default ICCardInput;
